export default __webpack_public_path__ + "static/media/3_Heaven and hell.8e50caeb.jpg";